import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { graphql, gql, compose } from 'react-apollo';

import RaisedButton from 'material-ui/RaisedButton';
import Loader from '../../UI/Loader';

import sortParticipants from '../../utils/sortParticipants';

import styles from './MergeTownParticipants.css';

const townParticipantsQuery = gql`
    query TownParticipantsQuery($townId: ID!) {
        town(_id: $townId) {
            _id
            name {
                ru
                local
            }
            tournament {
                _id
                p {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                m {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                t {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                v {
                    junior {
                        name
                        itemOf
                    }
                    senior {
                        name
                        itemOf
                    }
                }
                gradeSettings {
                    number
                    level
                    multiplier
                    russianEquivalent
                }
            }
            gradeSettings {
                number
                level
                multiplier
                russianEquivalent
            }
            participants {
                _id
                name
                fullName
                grade
                email
                school
                papers {
                    _id
                    round
                    level
                    marks
                }
            }
        }
    }
`;

const mergeParticipantsMutation = gql`
    mutation MergeParticipantsMutation($participantIds: [ID!]!) {
        mergeParticipants(participantIds: $participantIds) {
            _id
            name
            fullName
            grade
            email
            school
            papers {
                _id
                round
                level
                marks
            }
        }
    }
`;

class MergeTownParticipants extends Component {
    static propTypes = {};

    state = {
        selected: [],
    };

    componentWillReceiveProps(nextProps) {
        const {
            data: { town, loading },
        } = nextProps;

        if (!loading && town && town.participants && !this.state.participants) {
            this.setState({ participants: sortParticipants([...town.participants]) });
        }
    }

    handleParticipantClick = event => {
        const clickedId = event.currentTarget.dataset.id;
        const { selected } = this.state;

        if (selected.includes(clickedId)) {
            this.setState({
                selected: this.state.selected.filter(_id => _id !== clickedId),
            });
        } else {
            this.setState({
                selected: [...selected, clickedId],
            });
        }
    };

    handleMergeClick = async () => {
        const {
            data: { mergeParticipants: newParticipant },
        } = await this.props.mutate({
            variables: { participantIds: this.state.selected },
        });

        this.setState({
            selected: [],
            participants: sortParticipants([
                ...this.state.participants.filter(({ _id }) => !this.state.selected.includes(_id)),
                newParticipant,
            ]),
        });
    };

    render() {
        const {
            intl: { formatMessage },
            data: { town, loading },
        } = this.props;
        const { selected, participants } = this.state;

        if (loading) {
            return <Loader centerX />;
        }

        if (!town) {
            return (
                <h2>
                    <FormattedMessage id="Town.No such town" />
                </h2>
            );
        }

        if (!participants.length) {
            return (
                <h2>
                    <FormattedMessage id="Town.no participants" />
                </h2>
            );
        }

        let participantColors = [0];

        for (let i = 1; i < participants.length; i++) {
            if (
                participants[i].fullName
                    .trim()
                    .toLowerCase()
                    .replace(/ё/g, 'е') ===
                participants[i - 1].fullName
                    .trim()
                    .toLowerCase()
                    .replace(/ё/g, 'е')
            ) {
                participantColors[i] = participantColors[i - 1];
            } else {
                participantColors[i] = (participantColors[i - 1] + 1) % 2;
            }
        }

        return (
            <div>
                <h2>{town.name.ru || town.name.local}</h2>
                <div className={styles.mergeButtonContainer}>
                    <RaisedButton
                        primary
                        onClick={this.handleMergeClick}
                        label={formatMessage({ id: 'ParticipantList.merge' })}
                        disabled={selected.length < 2}
                    />
                </div>
                <ul className={styles.parcicipantsList}>
                    {participants.map((participant, i) => (
                        <li
                            data-id={participant._id}
                            onClick={this.handleParticipantClick}
                            key={participant._id}
                            className={classnames({
                                [styles.selected]: selected.includes(participant._id),
                                [styles.even]: !participantColors[i],
                                [styles.odd]: participantColors[i],
                            })}
                        >
                            <span className={styles.name}>{participant.fullName}</span>
                            {participant.grade}
                            -й {formatMessage({ id: 'EnterData.grade' }).toLowerCase()}, {participant.school}
                            <span className={styles.email}>{participant.email}</span>
                            <div className={styles.papers}>
                                {participant.papers.map(paper => `${paper.round}:${paper.level}`).join(', ')}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default compose(
    graphql(townParticipantsQuery, {
        options: ({ match }) => ({ variables: { townId: match.params.id }, fetchPolicy: 'no-cache' }),
    }),
    graphql(mergeParticipantsMutation),
    injectIntl
)(MergeTownParticipants);



// WEBPACK FOOTER //
// ./src/Components/MergeTownParticipants/MergeTownParticipants.js